export const RATING_LINK = '/bewertungen.php';
export const ARTICLES_LINK = '/rechtstipps.php';
